import React from 'react'

const GameShowItem = (props) => {
    return (
        <div>
            {props.player.handle}
        </div>
    )
}

export default GameShowItem;
